/** @module ChangeTracking/EnableChangeTrackingController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/locale",
	"csi/xml",
	"SiteAdmin/BusinessObject"
], function(declare, _, Controller, locale, xml, BusinessObject) {

	return declare(Controller, {
		/**
		 * Return form data for view. In this case, turn off selections and make editable
		 * @return {FormData}
		 */
		getFormData: function() {
			var fd = this.m_formData;
			if (!fd) {
				fd = this.inherited(arguments);
				fd.m_bAllowSelections = false;
				fd.m_bEditable = true;
			}

			return fd;
		},

		/**
		 * Return string rendered at top of popup dialog
		 * @return {string}
		 */
		getIntroString: function() {
			// NOTE: This will be turned into a wizard, so looking ahead and using resource name for that.
			return this.getString("_Detail0", [this._getDomainType()]);
		},

		/**
		 * Enable save button if writer has changed; protect against writer being null when controller is finishing up
		 * @param {Object} params
		 */
		onCreatePopupParams: function(params) {
			const {m_writer} = this;
			params.canEnableButton = (button, idAction) => m_writer && (m_writer.isChanged() || (idAction !== "Save"));
			params.writerForActions = m_writer;
		},

		/**
		 * If change was made, then mark node as modified
		 */
		publish: function() {
			var w = this.m_writer;
			if (w.isChanged()) {
				w.changeNode(this.m_urlNode).changeAttribute(BusinessObject.ATTR_MODIFIED, xml.ATTR_BOOLEAN, true);
			}

			this.inherited(arguments);
		},

		/**
		 * Redraw row if changes made
		 */
		postProcessSuccess: function() {
			return this.widget.postActionRedrawNode(this);
		},

		/**
		 * Return type for which tracking is being enabled
		 * @return {string}
		 */
		_getDomainType: function() {
			return locale.type(this.getNode().$Name);
		}
	});
});